import React from "react";
import { Tab, Nav, Card, Button } from "react-bootstrap";
import {
  ClipboardCheck,
  CalendarEvent,
  ClipboardData,
  HeartPulse,
  ListCheck,
  FileText,
  SignDeadEnd,
  SignIntersectionT,
  SignIntersection,
  Eye,
  ArrowLeft,
} from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import paths from "routes/paths";
import ClaimRequestProvider from "./ClaimRequestProvider";
import { useSelector } from "react-redux";
import ClaimProviderVitalSign from "./ClaimProviderVitalSign";
import ClaimProviderMedicalDetails from "./ClaimProviderMedicalDetails";
import ClaimProviderDiagnosis from "./ClaimProviderDiagnosis";
import ClaimProviderServices from "./ClaimProviderServices";
import ClaimProviderClinical from "./ClaimProviderClinical";
import ClaimProviderEncounter from "./ClaimProviderEncounter";
import ClaimProviderOptical from "./ClaimProviderOptical";
const ClaimProviderRequest = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <>
      <Tab.Container defaultActiveKey="preAuthRequest">
        <Card>
          <Nav
            variant="tabs"
            className="border-0 d-flex align-items-center mb-2 px-2"
          >
            {id && (
              <Button
                variant="secondary"
                className="me-3"
                size="sm"
                onClick={() => navigate(paths.claimsList)}
              >
                <ArrowLeft size={18} />
              </Button>
            )}
            {/* Pre-Authorization Request or Claim Request Tab */}
            <Nav.Item>
              <Nav.Link
                eventKey="preAuthRequest"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <ClipboardCheck /> Claim Request
              </Nav.Link>
            </Nav.Item>

            {/* Encounter Tab */}
            {/* {preauthorizationEncounter && ( */}
            {!!viewClaimInfo?.payload_json?.enct_stdate && (
              <Nav.Item>
                <Nav.Link
                  eventKey="encounter"
                  className="d-flex align-items-center fs-10 text-600 gap-2"
                >
                  <CalendarEvent />
                  Encounter
                </Nav.Link>
              </Nav.Item>
            )}
            {/* )} */}
            {viewClaimInfo?.claim_type === "vision" && (
              <Nav.Item>
                <Nav.Link
                  eventKey="optical"
                  className="d-flex align-items-center fs-10 text-600 gap-2"
                >
                  <Eye /> Optical
                </Nav.Link>
              </Nav.Item>
            )}
            {/* {viewPreauthorizationInfo?.claim_typenme !== "vision" && ( */}
            <Nav.Item>
              <Nav.Link
                eventKey="vital"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <SignIntersection />
                Vital Sign
              </Nav.Link>
            </Nav.Item>
            {/* )} */}

            {/* Medical Details Tab */}
            <Nav.Item>
              <Nav.Link
                eventKey="medicalDetails"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <ClipboardData /> Medical Details
              </Nav.Link>
            </Nav.Item>

            {/* Diagnosis Tab */}
            <Nav.Item>
              <Nav.Link
                eventKey="diagnosis"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <HeartPulse />
                Diagnosis
              </Nav.Link>
            </Nav.Item>

            {/* Services & Procedures Tab */}
            <Nav.Item>
              <Nav.Link
                eventKey="servicesProcedures"
                className="d-flex align-items-center fs-10 text-600 gap-2"
              >
                <ListCheck />
                Services & Procedures
              </Nav.Link>
            </Nav.Item>

            {/* Clinical Documentation Tab */}
            <Nav.Item>
              <Nav.Link
                eventKey="clinicalDoc"
                className="d-flex fs-10 text-600 align-items-center gap-2"
              >
                <FileText />
                Clinical Documentation
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="p-3">
            <Tab.Pane eventKey="preAuthRequest">
              <ClaimRequestProvider />
            </Tab.Pane>
            <Tab.Pane eventKey="vital">
              <ClaimProviderVitalSign />
            </Tab.Pane>
            <Tab.Pane eventKey="medicalDetails">
              <ClaimProviderMedicalDetails />
            </Tab.Pane>
            <Tab.Pane eventKey="diagnosis">
              <ClaimProviderDiagnosis />
            </Tab.Pane>
            <Tab.Pane eventKey="servicesProcedures">
              <ClaimProviderServices />
            </Tab.Pane>
            <Tab.Pane eventKey="clinicalDoc">
              <ClaimProviderClinical />
            </Tab.Pane>
            <Tab.Pane eventKey="encounter">
              <ClaimProviderEncounter />
            </Tab.Pane>

            {viewClaimInfo?.claim_type === "vision" && (
              <Tab.Pane eventKey="optical">
                <ClaimProviderOptical />
              </Tab.Pane>
            )}
          </Tab.Content>
        </Card>
      </Tab.Container>
    </>
  );
};
export default ClaimProviderRequest;
